import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
export var useResizeObserver = function useResizeObserver() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$defaultWidth = _ref.defaultWidth,
      defaultWidth = _ref$defaultWidth === void 0 ? 0 : _ref$defaultWidth,
      _ref$defaultHeight = _ref.defaultHeight,
      defaultHeight = _ref$defaultHeight === void 0 ? 0 : _ref$defaultHeight,
      defaultElement = _ref.defaultElement,
      _ref$borderBoxSize = _ref.borderBoxSize,
      borderBoxSize = _ref$borderBoxSize === void 0 ? false : _ref$borderBoxSize;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      element = _useState2[0],
      setElement = _useState2[1];

  var _useState3 = useState({
    width: defaultWidth,
    height: defaultHeight
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      size = _useState4[0],
      setSize = _useState4[1]; // Dynamic ref will not rerender and reinitiate ResizeObserver
  // `setElement` is fixing this issue


  var ref = function ref(node) {
    return setElement(node);
  };

  ref.current = element;
  var isDefaultElementChanged = defaultElement !== element;

  if (defaultElement && isDefaultElementChanged) {
    ref(defaultElement);
  }

  useEffect(function () {
    if (!element) {
      return;
    }

    var resizeObserver = new ResizeObserver(function (entries) {
      if (!entries.length) {
        return;
      }

      var _entries = _slicedToArray(entries, 1),
          entry = _entries[0];

      if (borderBoxSize) {
        setSize({
          width: entry.borderBoxSize[0].inlineSize,
          height: entry.borderBoxSize[0].blockSize
        });
      } else {
        setSize({
          width: entry.contentRect.width,
          height: entry.contentRect.height
        });
      }
    });
    resizeObserver.observe(element);
    return function () {
      return resizeObserver.disconnect();
    };
  }, [element, borderBoxSize]);
  return _objectSpread({
    ref: ref
  }, size);
};